var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8932 18.333H2.22656C1.8849 18.333 1.60156 18.0497 1.60156 17.708C1.60156 17.3663 1.8849 17.083 2.22656 17.083H18.8932C19.2349 17.083 19.5182 17.3663 19.5182 17.708C19.5182 18.0497 19.2349 18.333 18.8932 18.333Z",
    fill: "#EDEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68457 3.33366V18.3337H12.4346V3.33366C12.4346 2.41699 12.0596 1.66699 10.9346 1.66699H10.1846C9.05957 1.66699 8.68457 2.41699 8.68457 3.33366Z",
    fill: "#EDEDF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05957 8.33366V18.3337H6.3929V8.33366C6.3929 7.41699 6.05957 6.66699 5.05957 6.66699H4.3929C3.3929 6.66699 3.05957 7.41699 3.05957 8.33366Z",
    fill: "#EDEDF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7266 12.4997V18.333H18.0599V12.4997C18.0599 11.583 17.7266 10.833 16.7266 10.833H16.0599C15.0599 10.833 14.7266 11.583 14.7266 12.4997Z",
    fill: "#EDEDF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.8e7e651e8b2206ce82a346373e484923.svg";
export { ForwardRef as ReactComponent };